import React, { useRef, useState } from 'react';
import { Play, Pause } from 'lucide-react'; // or any icons you like

const AudioPlayer = ({ src }) => {
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);

    const togglePlay = () => {
        const audio = audioRef.current;
        if (audio.paused) {
            audio.play();
            setIsPlaying(true);
        } else {
            audio.pause();
            setIsPlaying(false);
        }
    };

    const handleTimeUpdate = () => {
        const audio = audioRef.current;
        setProgress((audio.currentTime / audio.duration) * 100);
    };

    const handleLoadedMetadata = () => {
        setDuration(audioRef.current.duration);
    };

    const formatTime = (secs) => {
        const m = Math.floor(secs / 60);
        const s = Math.floor(secs % 60);
        return `${m}:${s < 10 ? '0' : ''}${s}`;
    };

    return (
        <div className="flex items-center gap-2 bg-gray-100 rounded-full px-3 py-2 w-full max-w-xs">
            <button onClick={togglePlay}>
                {isPlaying ? <Pause size={20} className='text-primary' /> : <Play size={20} className='text-primary' />}
            </button>
            <input
                type="range"
                value={progress}
                onChange={(e) => {
                    const audio = audioRef.current;
                    const newProgress = parseFloat(e.target.value);
                    const newTime = (newProgress / 100) * audio.duration;
                    audio.currentTime = newTime;
                    setProgress(newProgress);
                }}
                className="w-full accent-blue-500 h-1"
            />
            <span className="text-xs text-gray-600 w-10 text-right">
                {formatTime(duration)}
            </span>
            <audio
                ref={audioRef}
                src={src}
                onTimeUpdate={handleTimeUpdate}
                onLoadedMetadata={handleLoadedMetadata}
                onEnded={() => setIsPlaying(false)}
            />
        </div>
    );
};

export default AudioPlayer;
